import {isNotNullOrUndefined} from '@benchling/js-utils';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {pluralize} from 'BenchlingUtil';
import {FONT_WEIGHT_PROXIMA_SEMIBOLD} from 'styles/FontConstants';
import getTestProps from 'test/lib/cypress/getTestProps';
import * as Colors from 'ui-library/Colors';

export interface CompactListingBannerProps {
  total: number | null;
  isExact: boolean | null;
  subtext?: string | null;
}

function createResultsString(
  total?: number | null,
  isExact?: boolean | null,
  subtext?: string | null
): string {
  if (total == null) {
    return 'Loading...';
  }

  const preText = isNotNullOrUndefined(isExact) && !isExact ? 'More than ' : '';
  const postText = subtext ? `, ${subtext}` : '';
  return `${preText}${total} ${pluralize(total, 'result')}${postText}`;
}

export default function CompactListingBanner(props: CompactListingBannerProps): JSX.Element {
  return (
    <div
      className={css(styles.banner)}
      {...getTestProps({component: 'CompactListingBanner', element: 'root'})}
    >
      <div>{createResultsString(props.total, props.isExact, props.subtext)}</div>
    </div>
  );
}

const styles = StyleSheet.create({
  banner: {
    alignItems: 'flex-start',
    backgroundColor: Colors.GRAY_LIGHTER,
    color: Colors.GRAY_DARK,
    display: 'flex',
    flex: 1,
    fontWeight: FONT_WEIGHT_PROXIMA_SEMIBOLD,
    justifyContent: 'space-between',
    padding: '10px 14px',
  },
});
